<template>
  <div>
    <div v-for="utilityPod in utilityPodsErrors" v-bind:key="utilityPod.pod.id" class="bg-error">
      {{$replaceT(utilityPod.error.code, utilityPod.error.params, utilityPod.error.content)}}
    </div>
  </div>
</template>

<script>
import { useServiceStore } from '@/stores/ServiceStore.js'

export default {
  name: "UtilityPodsErrors",
  mounted: function() {
    const serviceStore = useServiceStore();
    serviceStore.resetUtilityPods();
  },
  computed: {
    utilityPodsErrors: function() {
      const serviceStore = useServiceStore();
      return serviceStore.getUtilityPodsErrors;
    },
  }
}
</script>

<style>

</style>
